import {Clock} from 'lucide-react';
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {Button, Empty, Tag} from "antd";
import {mapWeeklySchedule} from "@/pages/teacher/weekly/WeeklySchedule";
import RenderIf from "@/components/render-if";


export default function TodayClass({teacherDashboard}) {
    let today = new Date().getDay() + 1;
    if (today === 7) {
        today = 0;
    }
    const myClass = mapWeeklySchedule(teacherDashboard?.data?.data?.today_class);


    return (
        <div className="rounded-xl shadow-sm border border-gray-100 dark:border-slate-700 p-6 bg-white dark:bg-slate-900">
            <div className="flex flex-wrap items-center justify-between mb-6">
                <div className="flex items-center gap-2">
                    <Clock className="w-5 h-5 text-gray-700 dark:text-slate-300"/>
                    <h2 className="text-lg font-bold text-gray-800 dark:text-slate-100">کلاس‌های امروز</h2>
                </div>

                <div className="flex items-center gap-2">
                    <Link to={URLS.teacher.weekly.dashboard}>
                        <Button variant={'link'} type={'link'}>مشاهده برنامه هفتگی</Button>
                    </Link>
                </div>
            </div>

            <div className="w-full">
                <RenderIf condition={teacherDashboard?.data?.data?.today_class.length === 0}>
                    <Empty description={'امروز هیچ کلاسی ندارید'}/>
                </RenderIf>

                <RenderIf condition={teacherDashboard?.data?.data?.today_class.length > 0}>
                    {myClass.map((day, index) => {
                        if (index !== today) {
                            return null;
                        }
                        return (
                            <div
                                key={'schedule-' + day + '-' + index}
                                className="w-full flex-shrink-0 rounded-lg p-3 transition-all duration-200 bg-blue-50 dark:bg-blue-950/30 border-2 border-blue-500 dark:border-blue-400"
                            >
                                <div className="text-center mb-3">
                                    <p className="text-sm font-semibold text-blue-600 dark:text-blue-400">
                                        {day.day}
                                    </p>
                                </div>

                                <div className="space-y-2">
                                    {day.classes.length > 0 ? (
                                        day.classes.map((cls, idx) => (
                                            <Link
                                                key={idx}
                                                to={sprintf(URLS.teacher.lessons.detail, {id: cls?.lesson_id})}
                                            >
                                                <div
                                                    className="border border-solid border-white dark:border-slate-700 hover:border-gray-300 dark:hover:border-slate-500 text-xs p-2 rounded shadow-sm bg-white dark:bg-slate-800 transition-colors"
                                                >
                                                    <div className="flex flex-wrap justify-between mb-1">
                                                        <Tag color={'green'}>{cls.code}</Tag>
                                                        <p className="font-semibold text-gray-800 dark:text-slate-200 mb-1">
                                                            {cls.time} - {cls.end_time}
                                                        </p>
                                                    </div>

                                                    <p className="text-gray-700 dark:text-slate-200 leading-tight">
                                                        <span>{cls.topic}</span>

                                                        <span className="text-xs text-gray-500 dark:text-slate-400 block">
                                                            {cls.subject}
                                                        </span>
                                                    </p>
                                                </div>
                                            </Link>
                                        ))
                                    ) : (
                                        <p className="text-xs text-gray-500 dark:text-slate-400 text-center py-2">
                                            بدون کلاس
                                        </p>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </RenderIf>
            </div>
        </div>
    );
}